export default "__VITE_ASSET__BKm6mOwN__"